// extracted by mini-css-extract-plugin
export default {"navLink":"home_navLink__xO-ao","col":"home_col__eqESi"};